


// Cart Animations & Scripts

    // Universal Icon Button Handler
    document.addEventListener('click', function(e) {
        const button = e.target.closest('button, a');
        if (!button) return;

        // Universal - runs for ANY button that has an .icon_wrapper
        const iconWrapper = button.querySelector('.icon_wrapper');
        if (iconWrapper) {
            iconWrapper.querySelectorAll('div').forEach(div => {
            div.classList.toggle('clicked');
            });
        }

        // Cart specific - only runs when #cart-button is clicked
        if (button.id === 'cart-button') {
            document.querySelector('.cart_wrapper').classList.toggle('open');
            document.querySelector('.checkout_wrapper').classList.toggle('open');
            updateCartTotal();
        }

    });

    // Cart Total Refresh Script
        function updateCartTotal() {
            fetch('/cart.js')
                .then(response => response.json())
                .then(cart => {
                    const cartTotal = document.getElementById('cart-total');
                    cartTotal.textContent = formatMoney(cart.total_price);
                });
        }

        // Shopify Stores Prices in cents, this convers to dollars
        function formatMoney(cents) {
            const format = window.Shopify.money_format || '${{amount}}';
            const amount = (cents / 100).toFixed(2);
            return format.replace('{{amount}}', amount)
                        .replace('{{amount_no_decimals}}', Math.floor(cents / 100))
                        .replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
        }

        // Run on page load
        updateCartTotal();

    // Cart Quantity + Remove Scripts
        // Cart Item Controls
        document.addEventListener('click', function(e) {

        // Increase quantity
        if (e.target.matches('[data-action="increase"]')) {
            const line = e.target.dataset.line;
            updateLineItem(line, 1);
        }

        // Decrease quantity
        if (e.target.matches('[data-action="decrease"]')) {
            const line = e.target.dataset.line;
            updateLineItem(line, -1);
        }

        // Remove bundle
        if (e.target.closest('[data-action="remove-bundle"]')) {
            const bundleId = e.target.closest('[data-action="remove-bundle"]').dataset.bundleId;
            removeBundleItems(bundleId);
            return;
        }

        // Remove item
        if (e.target.closest('.button.close')) {
            const line = e.target.closest('.button.close').dataset.line;
            removeLineItem(line);
        }

        });

        function updateLineItem(line, change) {
        // First fetch current quantity
        fetch('/cart.js')
            .then(res => res.json())
            .then(cart => {
            const item = cart.items[line - 1]; // line is 1-indexed
            const newQty = item.quantity + change;

            if (newQty <= 0) {
                removeLineItem(line);
                return;
            }

            fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ line: line, quantity: newQty })
            })
            .then(res => res.json())
            .then(() => refreshCart());
            });
        }

        function removeLineItem(line) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: line, quantity: 0 })
        })
        .then(res => res.json())
        .then(() => refreshCart());
        }

        // Remove an entire bundle (box + all its flavors)
        function removeBundleItems(bundleId) {
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                    // Build updates object — set quantity to 0 for all items in this bundle
                    // Shopify's /cart/update.js accepts { updates: { variantId: qty } }
                    // but that merges by variant. We need line-based removal for bundles
                    // that might share variant IDs with other bundles.
                    // Instead, remove items sequentially from highest line to lowest
                    // so line numbers don't shift during removal.
                    const linesToRemove = [];
                    cart.items.forEach((item, index) => {
                        if (item.properties?._bundle_id === bundleId) {
                            linesToRemove.push(index + 1);
                        }
                    });

                    // Remove from highest line number first to avoid index shifting
                    linesToRemove.sort((a, b) => b - a);

                    let chain = Promise.resolve();
                    linesToRemove.forEach(line => {
                        chain = chain.then(() =>
                            fetch('/cart/change.js', {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ line: line, quantity: 0 })
                            }).then(res => res.json())
                        );
                    });

                    chain.then(() => refreshCart());
                });
        }

    // Cart Refresh Function
        function refreshCart() {
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => {
                updateCartTotal();
                renderCartItems(cart.items);
                });
            }

            function renderCartItems(items) {
            const list = document.getElementById('cart-item-list');

            if (items.length === 0) {
                list.innerHTML = '<p class="cart_empty">Your cart is empty</p>';
                return;
            }

            // Group items: bundles together, standalone items separate
            const bundles = {};
            const standalone = [];

            items.forEach((item, index) => {
                const bundleId = item.properties?._bundle_id;
                const bundleRole = item.properties?._bundle_role;

                if (bundleId) {
                    if (!bundles[bundleId]) bundles[bundleId] = { box: null, flavors: [] };
                    if (bundleRole === 'box') {
                        bundles[bundleId].box = { ...item, line: index + 1 };
                    } else {
                        bundles[bundleId].flavors.push({ ...item, line: index + 1 });
                    }
                } else {
                    standalone.push({ ...item, line: index + 1 });
                }
            });

            let html = '';

            // Render bundles
            Object.keys(bundles).forEach(bundleId => {
                const bundle = bundles[bundleId];
                const box = bundle.box;
                if (!box) return;

                const flavorSummary = bundle.flavors.map(f =>
                    `${f.quantity}x ${f.product_title}`
                ).join(', ');

                html += `
                    <div class="cart_item cart_bundle" data-bundle-id="${bundleId}" data-variant-id="${box.variant_id}" data-line="${box.line}">
                        <div class="cart_item__image">
                            <img src="${box.image}" alt="${box.title}">
                            <button class="button small close" data-action="remove-bundle" data-bundle-id="${bundleId}">
                                ✕
                            </button>
                        </div>
                        <div class="cart_item__details">
                            <span class="text-size-medium text-style-bold">
                                ${box.product_title}
                            </span>
                            ${box.variant_title !== 'Default Title' ? `
                                <span class="text-size-small">
                                    ${box.variant_title}
                                </span>
                            ` : ''}
                            <span class="text-size-xsm text-color-primary cart_bundle__flavors">
                                ${flavorSummary}
                            </span>
                            ${box.selling_plan_allocation ? `
                                <span class="text-size-xsm">
                                    ${box.selling_plan_allocation.selling_plan.name}
                                </span>
                            ` : ''}
                            <span class="cart_item__price">
                                ${formatMoney(box.final_line_price)}
                            </span>
                        </div>
                    </div>
                `;
            });

            // Render standalone items
            standalone.forEach(item => {
                html += `
                    <div class="cart_item" data-variant-id="${item.variant_id}" data-line="${item.line}">
                        <div class="cart_item__image">
                            <img src="${item.image}" alt="${item.title}">
                            <div class="quantity_wrapper float">
                                <button class="button small" data-action="decrease" data-line="${item.line}">
                                    -
                                </button>
                                <span class="text-color-secondary">
                                    ${item.quantity}
                                </span>
                                <button class="button small" data-action="increase" data-line="${item.line}">
                                    +
                                </button>
                            </div>
                            <button class="button small close" data-line="${item.line}">
                                ✕
                            </button>
                        </div>
                        <div class="cart_item__details">
                            <span class="text-size-medium text-style-bold">
                                ${item.product_title}
                            </span>
                            ${item.variant_title !== 'Default Title' ? `
                                <span class="text-size-small">
                                    ${item.variant_title}
                                </span>
                            ` : ''}
                            ${item.selling_plan_allocation ? `
                                <span class="text-size-xsm">
                                    ${item.selling_plan_allocation.selling_plan.name}
                                </span>
                            ` : ''}
                            <span class="cart_item__price">
                                ${formatMoney(item.final_line_price)}
                            </span>
                        </div>
                    </div>
                `;
            });

            list.innerHTML = html;
        }

// Banner Animations

const banner = document.getElementById('site-banner');
const bannerClose = document.getElementById('banner-close');

if (banner && bannerClose) {
  bannerClose.addEventListener('click', function() {
    banner.classList.add('is-hidden');
    sessionStorage.setItem('banner-dismissed', 'true');
  });

  // Keep dismissed if user navigates to another page
  if (sessionStorage.getItem('banner-dismissed') === 'true') {
    banner.classList.add('is-hidden');
  }
}

// Menu Filters - scoped to .menu_filters only
document.addEventListener('click', function(e) {
  const filterBtn = e.target.closest('.menu_filters .filter_btn');
  if (!filterBtn) return;

  // Update active filter button
  document.querySelectorAll('.menu_filters .filter_btn').forEach(btn => {
    btn.classList.remove('active');
  });
  filterBtn.classList.add('active');

  const filter = filterBtn.dataset.filter;

  // Show / hide cards
  document.querySelectorAll('.product_card').forEach(card => {
    if (filter === 'all' || card.dataset.type === filter) {
      card.classList.remove('is-hidden');
    } else {
      card.classList.add('is-hidden');
    }
  });
});

// PRODUCT MODAL

    // Open modal when clicking a product card (not inside the modal itself)
    document.addEventListener('click', function(e) {
        const card = e.target.closest('.product_card');
        if (!card) return;
        // Don't re-trigger if clicking inside the modal's product card
        if (e.target.closest('.product_modal')) return;

        const productData = JSON.parse(card.dataset.productJson);
        const sellingPlans = card.dataset.sellingPlans ? JSON.parse(card.dataset.sellingPlans) : [];
        const orderCutoff = card.dataset.orderCutoff || '';
        const linkedProducts = card.dataset.linkedProducts ? JSON.parse(card.dataset.linkedProducts) : [];
        openProductModal(productData, sellingPlans, orderCutoff, linkedProducts);
    });

    function openProductModal(product, sellingPlans, orderCutoff, linkedProducts) {
        const content = document.getElementById('product-modal-content');
        const modal = document.getElementById('product-modal');
        const backdrop = document.getElementById('product-modal-backdrop');

        // Find first available variant
        const firstAvailable = product.variants.find(v => v.available) || product.variants[0];

        // Build variant options HTML
        let optionsHTML = '';
        if (product.options && product.options.length > 0 && !(product.options.length === 1 && product.options[0] === 'Title')) {
            optionsHTML = '<div class="product_card__options">';
            product.options.forEach((optionName, index) => {
                const values = [...new Set(product.variants.map(v => v[`option${index + 1}`]))];
                optionsHTML += `
                    <div class="product_card__option_group">
                        <p class="text-size-small text-color-primary">${optionName}</p>
                        <div class="product_card__option_values">
                            ${values.map(value => {
                                const isAvailable = product.variants.some(v =>
                                    v[`option${index + 1}`] === value && v.available
                                );
                                const isActive = firstAvailable[`option${index + 1}`] === value;
                                return `
                                    <button class="button small option_btn ${isActive ? 'active' : ''} ${!isAvailable ? 'sold_out' : ''}"
                                        data-option-index="${index + 1}"
                                        data-option-value="${value}">
                                        ${value}${!isAvailable ? ' - Sold Out' : ''}
                                    </button>
                                `;
                            }).join('')}
                        </div>
                    </div>
                `;
            });
            optionsHTML += '</div>';
        }

        // Build subscription plans HTML
        let subscriptionsHTML = '';
        if (sellingPlans && sellingPlans.length > 0) {
            sellingPlans.forEach(group => {
                subscriptionsHTML += `
                    <div class="product_card__subscriptions">
                        <p class="text-size-medium text-color-primary">${group.name}</p>
                        <div class="product_card__subscription_options">
                            <button class="button option_btn active"
                                data-selling-plan=""
                                data-price="${firstAvailable.price}">
                                One Time
                            </button>
                            ${group.selling_plans.map(plan => `
                                <button class="button option_btn"
                                    data-selling-plan="${plan.id}"
                                    data-price="${plan.price_adjustments && plan.price_adjustments[0] ? plan.price_adjustments[0].value : firstAvailable.price}">
                                    ${plan.name}
                                </button>
                            `).join('')}
                        </div>
                    </div>
                `;
            });
        }

        // Build description HTML
        let descriptionHTML = '';
        if (product.description && product.description.trim() !== '') {
            descriptionHTML = `
                <div class="product_card__description text-color-primary text-size-small">
                    ${product.description}
                </div>
            `;
        }

        // Build flavor picker HTML for cookie box products
        let flavorPickerHTML = '';
        if (linkedProducts && linkedProducts.length > 0) {
            flavorPickerHTML = `
                <div class="flavor_picker" data-linked-products='${JSON.stringify(linkedProducts).replace(/'/g, "&#39;")}'>
                    <div class="flavor_picker__header">
                        <p class="text-size-medium text-color-primary">Choose Your Flavors</p>
                        <p class="flavor_picker__counter text-size-small text-color-primary">
                            <span class="flavor_picker__selected">0</span> of <span class="flavor_picker__max">0</span> selected
                        </p>
                    </div>
                    <div class="flavor_picker__list">
                        ${linkedProducts.map(fp => {
                            const fpVariant = fp.variants.find(v => v.available) || fp.variants[0];
                            return `
                                <div class="flavor_picker__item ${!fp.available ? 'unavailable' : ''}"
                                    data-flavor-variant-id="${fpVariant.id}"
                                    data-flavor-product-id="${fp.id}"
                                    data-flavor-available="${fp.available}">
                                    <div class="flavor_picker__item_image">
                                        ${fp.featured_image ? `<img src="${fp.featured_image}" alt="${fp.title}" loading="lazy">` : ''}
                                    </div>
                                    <div class="flavor_picker__item_info">
                                        <span class="text-size-small text-color-primary">${fp.title}</span>
                                        ${!fp.available ? '<span class="text-size-xsm text-color-primary">Sold Out</span>' : ''}
                                    </div>
                                    ${fp.available ? `
                                        <div class="quantity_wrapper flavor_picker__qty">
                                            <button class="button small" data-action="flavor-decrease" ${true ? 'disabled' : ''}>-</button>
                                            <span class="text-color-secondary">0</span>
                                            <button class="button small" data-action="flavor-increase">+</button>
                                        </div>
                                    ` : ''}
                                </div>
                            `;
                        }).join('')}
                    </div>
                </div>
            `;
        }

        // Determine if this is a cookie box product (has linked products)
        const isCookieBox = linkedProducts && linkedProducts.length > 0;

        // Build the full modal content
        content.innerHTML = `
            <div class="product_card product_modal__grid ${isCookieBox ? 'cookie_box' : ''}" data-product-json='${JSON.stringify(product).replace(/'/g, "&#39;")}'>

                <div class="product_modal__image">
                    <div class="product_card__image">
                        ${product.featured_image ? `
                            <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
                        ` : ''}
                    </div>
                </div>

                <div class="product_modal__buying">
                    <div class="product_card__info text-color-primary">
                        <p class="text-size-xlarge text-style-bold">${product.title}</p>
                    </div>

                    ${optionsHTML}
                    ${subscriptionsHTML}
                    ${flavorPickerHTML}

                    <div class="column_wrapper expand_width">
                        ${!isCookieBox ? `
                            <div class="row_wrapper text-color-primary">
                                <div class="quantity_wrapper">
                                    <button class="button small" data-action="decrease">-</button>
                                    <span class="text-color-secondary">1</span>
                                    <button class="button small" data-action="increase">+</button>
                                </div>
                                <span id="product-price" class="text-size-large">${formatMoney(firstAvailable.price)}</span>
                            </div>
                        ` : `
                            <div class="row_wrapper text-color-primary">
                                <span id="product-price" class="text-size-large">${formatMoney(firstAvailable.price)}</span>
                            </div>
                        `}
                        <button class="button product_card__button expand_width"
                            data-variant-id="${firstAvailable.id}"
                            ${isCookieBox ? 'disabled data-action="add-bundle-to-cart"' : (firstAvailable.available ? 'data-action="add-to-cart"' : 'disabled')}>
                            ${isCookieBox ? 'Select Your Flavors' : (firstAvailable.available ? 'Add to Cart' : 'Sold Out')}
                        </button>
                        ${orderCutoff ? `
                            <p class="product_modal__cutoff text-size-small text-color-primary">
                                ${orderCutoff}
                            </p>
                        ` : ''}
                    </div>
                </div>

                ${descriptionHTML ? `<div class="product_modal__description">${descriptionHTML}</div>` : ''}

            </div>
        `;

        // If cookie box, initialize the flavor picker and attach direct click handler
        if (isCookieBox) {
            updateFlavorPickerMax();

            const bundleBtn = content.querySelector('[data-action="add-bundle-to-cart"]');
            if (bundleBtn) {
                bundleBtn.addEventListener('click', function() {
                    handleBundleAddToCart(bundleBtn);
                });
            }
        }

        // Show modal
        modal.classList.add('open');
        backdrop.classList.add('open');
        document.body.style.overflow = 'hidden';
    }

    // Cookie Box: Get the max flavor count from the selected variant name
    // Expects variant names like "Single", "x4", "x6" — parses the number
    function getMaxFlavorsFromVariant(card) {
        const productData = JSON.parse(card.dataset.productJson);
        const variantId = card.querySelector('.product_card__button').dataset.variantId;
        const variant = productData.variants.find(v => String(v.id) === String(variantId));
        if (!variant) return 1;

        // Try to extract number from variant title (e.g., "x4" → 4, "x6" → 6, "Single" → 1)
        const title = variant.title || '';
        const match = title.match(/(\d+)/);
        if (match) return parseInt(match[1]);
        if (title.toLowerCase().includes('single')) return 1;
        return 1;
    }

    // Cookie Box: Update the max count display and button state
    function updateFlavorPickerMax() {
        const card = document.querySelector('.product_modal__content .product_card');
        if (!card || !card.classList.contains('cookie_box')) return;

        const max = getMaxFlavorsFromVariant(card);
        const maxSpan = card.querySelector('.flavor_picker__max');
        if (maxSpan) maxSpan.textContent = max;

        updateFlavorPickerState();
    }

    // Cookie Box: Update selected count and add-to-cart button state
    function updateFlavorPickerState() {
        const card = document.querySelector('.product_modal__content .product_card');
        if (!card || !card.classList.contains('cookie_box')) return;

        const max = getMaxFlavorsFromVariant(card);
        let totalSelected = 0;

        card.querySelectorAll('.flavor_picker__item').forEach(item => {
            const span = item.querySelector('.flavor_picker__qty span');
            if (span) totalSelected += parseInt(span.textContent) || 0;
        });

        // Update counter
        const selectedSpan = card.querySelector('.flavor_picker__selected');
        if (selectedSpan) selectedSpan.textContent = totalSelected;

        // Update add-to-cart button
        const addBtn = card.querySelector('.product_card__button');
        if (totalSelected === max) {
            addBtn.disabled = false;
            addBtn.textContent = 'Add to Cart';
        } else if (totalSelected > max) {
            addBtn.disabled = true;
            addBtn.textContent = `Too many selected (${totalSelected}/${max})`;
        } else {
            addBtn.disabled = true;
            addBtn.textContent = `Select ${max - totalSelected} more flavor${max - totalSelected !== 1 ? 's' : ''}`;
        }

        // Disable increase buttons if at max
        card.querySelectorAll('[data-action="flavor-increase"]').forEach(btn => {
            btn.disabled = totalSelected >= max;
        });

        // Disable decrease buttons if at 0
        card.querySelectorAll('.flavor_picker__item').forEach(item => {
            const span = item.querySelector('.flavor_picker__qty span');
            const qty = parseInt(span?.textContent) || 0;
            const decBtn = item.querySelector('[data-action="flavor-decrease"]');
            if (decBtn) decBtn.disabled = qty <= 0;
        });
    }

    function closeProductModal() {
        const modal = document.getElementById('product-modal');
        const backdrop = document.getElementById('product-modal-backdrop');
        const content = document.getElementById('product-modal-content');

        modal.classList.remove('open');
        backdrop.classList.remove('open');
        document.body.style.overflow = '';

        // Clear content after animation
        setTimeout(function() {
            content.innerHTML = '';
        }, 400);
    }

    // Close modal on X button
    document.addEventListener('click', function(e) {
        if (e.target.closest('#product-modal-close')) {
            closeProductModal();
        }
    });

    // Close modal on backdrop click
    document.addEventListener('click', function(e) {
        if (e.target.id === 'product-modal-backdrop') {
            closeProductModal();
        }
    });

    // Close modal on Escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeProductModal();
        }
    });

// VARIANT AND SUBSCRIPTION SELECTORS

    // Subscription Option Buttons - scoped to .product_card__subscription_options only
    document.addEventListener('click', function(e) {
    const planBtn = e.target.closest('.product_card__subscription_options .option_btn');
    if (!planBtn) return;

    const card = planBtn.closest('.product_card');

    // Update active plan button within this card only
    card.querySelectorAll('.product_card__subscription_options .option_btn').forEach(btn => {
        btn.classList.remove('active');
    });
    planBtn.classList.add('active');

    // Store selling plan on the add-to-cart button
    const addToCartButton = card.querySelector('.product_card__button');
    addToCartButton.dataset.sellingPlan = planBtn.dataset.sellingPlan;
    });

// Product Card Quantity Controls

    document.addEventListener('click', function(e) {
        const button = e.target.closest('.product_card .quantity_wrapper button');
        if (!button) return;
        // Skip if this is a flavor picker quantity control
        if (button.closest('.flavor_picker__qty')) return;

        const card = button.closest('.product_card');
        const quantitySpan = card.querySelector('.quantity_wrapper:not(.flavor_picker__qty) span');
        if (!quantitySpan) return;
        let currentQty = parseInt(quantitySpan.textContent);

        if (button.dataset.action === 'increase') {
            currentQty++;
        } else if (button.dataset.action === 'decrease' && currentQty > 1) {
            currentQty--;
        }

        quantitySpan.textContent = currentQty;
    });

    // Flavor Picker Quantity Controls (Cookie Box)
    document.addEventListener('click', function(e) {
        const btn = e.target.closest('[data-action="flavor-increase"], [data-action="flavor-decrease"]');
        if (!btn) return;

        const item = btn.closest('.flavor_picker__item');
        const span = item.querySelector('.flavor_picker__qty span');
        let qty = parseInt(span.textContent) || 0;

        if (btn.dataset.action === 'flavor-increase') {
            qty++;
        } else if (btn.dataset.action === 'flavor-decrease' && qty > 0) {
            qty--;
        }

        span.textContent = qty;
        updateFlavorPickerState();
    });

    // Cookie Box: When variant changes, update the flavor max
    // (This hooks into the existing variant selector click handler)
    document.addEventListener('click', function(e) {
        const optionBtn = e.target.closest('.cookie_box .product_card__option_values .option_btn');
        if (!optionBtn) return;
        // Let the existing variant handler fire first, then update flavor picker
        setTimeout(updateFlavorPickerMax, 10);
    });

    // Add to Cart Functionality (regular products)
    document.addEventListener('click', function(e) {
    if (!e.target.closest('[data-action="add-to-cart"]')) return;

    const button = e.target.closest('[data-action="add-to-cart"]');
    const card = button.closest('.product_card');
    const variantId = button.dataset.variantId;
    const sellingPlan = button.dataset.sellingPlan;

    // Get quantity from the product card
    const quantitySpan = card.querySelector('.quantity_wrapper span');
    const quantity = parseInt(quantitySpan.textContent) || 1;

    const body = {
        id: variantId,
        quantity: quantity
    };

    // Only include selling_plan if one is selected
    if (sellingPlan && sellingPlan !== '') {
        body.selling_plan = sellingPlan;
    }

    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
    })
    .then(res => res.json())
    .then(() => {
        refreshCart();
        // Open cart after adding item
        document.querySelector('.cart_wrapper').classList.add('open');
        document.querySelector('.checkout_wrapper').classList.add('open');
        // Close the product modal
        closeProductModal();
    });
    });

    // Add Bundle to Cart (Cookie Box products)
    function handleBundleAddToCart(button) {
        const card = button.closest('.product_card');
        const boxVariantId = button.dataset.variantId;
        const sellingPlan = button.dataset.sellingPlan;
        const bundleId = 'box_' + Date.now();

        // Disable button during add
        button.disabled = true;
        button.textContent = 'Adding...';

        // Collect selected flavors
        const flavors = [];
        card.querySelectorAll('.flavor_picker__item').forEach(item => {
            const span = item.querySelector('.flavor_picker__qty span');
            const qty = parseInt(span?.textContent) || 0;
            if (qty > 0) {
                const name = item.querySelector('.flavor_picker__item_info span').textContent.trim();
                flavors.push({
                    id: item.dataset.flavorVariantId,
                    quantity: qty,
                    name: name
                });
            }
        });

        // Build a human-readable flavor summary for the order
        const flavorSummary = flavors.map(f => `${f.quantity}x ${f.name}`).join(', ');

        // Build items array for /cart/add.js
        const items = [];

        // Add the box with visible flavor summary
        const boxItem = {
            id: boxVariantId,
            quantity: 1,
            properties: {
                '_bundle_id': bundleId,
                '_bundle_role': 'box',
                'Flavors': flavorSummary
            }
        };
        if (sellingPlan && sellingPlan !== '') {
            boxItem.selling_plan = sellingPlan;
        }
        items.push(boxItem);

        // Add each flavor
        flavors.forEach(flavor => {
            items.push({
                id: flavor.id,
                quantity: flavor.quantity,
                properties: {
                    '_bundle_id': bundleId,
                    '_bundle_role': 'flavor'
                }
            });
        });

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
        })
        .then(res => {
            if (!res.ok) return res.json().then(err => { throw err; });
            return res.json();
        })
        .then(() => {
            refreshCart();
            document.querySelector('.cart_wrapper').classList.add('open');
            document.querySelector('.checkout_wrapper').classList.add('open');
            closeProductModal();
        })
        .catch(err => {
            console.error('Bundle add to cart failed:', err);
            button.disabled = false;
            button.textContent = 'Add to Cart';
        });
    }


    // Variant Option Buttons
document.addEventListener('click', function(e) {
  const optionBtn = e.target.closest('.product_card__option_values .option_btn');
  if (!optionBtn) return;

  const card = optionBtn.closest('.product_card');
  const optionGroup = optionBtn.closest('.product_card__option_values');

  // Update active button within this option group only
  optionGroup.querySelectorAll('.option_btn').forEach(btn => {
    btn.classList.remove('active');
  });
  optionBtn.classList.add('active');

  // Build selected options array from all active buttons in this card
  const selectedOptions = [];
  card.querySelectorAll('.product_card__option_group').forEach(group => {
    const activeBtn = group.querySelector('.option_btn.active');
    if (activeBtn) {
      selectedOptions.push(activeBtn.dataset.optionValue);
    }
  });

  // Find the matching variant from the embedded product JSON
  const productData = JSON.parse(card.dataset.productJson);
  const matchedVariant = productData.variants.find(variant => {
    return selectedOptions.every((value, index) => {
      return variant[`option${index + 1}`] === value;
    });
  });

  if (matchedVariant) {
    const addToCartButton = card.querySelector('.product_card__button');
    addToCartButton.dataset.variantId = matchedVariant.id;

    // Update price
    const priceEl = card.querySelector('#product-price');
    priceEl.textContent = formatMoney(matchedVariant.price);

    // Determine the correct action based on product type
    const isCookieBox = card.classList.contains('cookie_box');
    const cartAction = isCookieBox ? 'add-bundle-to-cart' : 'add-to-cart';

    // Handle unavailable variant
    if (!matchedVariant.available) {
      addToCartButton.disabled = true;
      addToCartButton.textContent = 'Sold Out';
      addToCartButton.removeAttribute('data-action');
      // Disable flavor picker if this is a cookie box
      if (isCookieBox) {
        const picker = card.querySelector('.flavor_picker');
        if (picker) picker.classList.add('unavailable');
      }
    } else if (isCookieBox) {
      // Re-enable flavor picker and re-validate flavor selection
      const picker = card.querySelector('.flavor_picker');
      if (picker) picker.classList.remove('unavailable');
      addToCartButton.setAttribute('data-action', cartAction);
      updateFlavorPickerState();
    } else {
      addToCartButton.disabled = false;
      addToCartButton.textContent = 'Add to Cart';
      addToCartButton.setAttribute('data-action', cartAction);
    }
  }
});

// Initialize cart on page load
document.addEventListener('DOMContentLoaded', function() {
    refreshCart();

    // Initialize Swiper for reviews section
    if (document.querySelector('.reviews-swiper')) {
        new Swiper('.reviews-swiper', {
            slidesPerView: 1,
            spaceBetween: 20,
            loop: true,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                },
            },
        });
    }
});

// Bakery Menu - force download of order forms served from the Shopify CDN
// (cross-origin, so the plain `download` attribute is ignored by browsers).
document.addEventListener('click', function(e) {
  const link = e.target.closest('[data-download-file]');
  if (!link) return;
  if (!window.fetch || !window.URL || !URL.createObjectURL) return; // fall back to opening in a new tab

  e.preventDefault();

  const href = link.getAttribute('href');
  const baseName = link.getAttribute('data-download-name') || 'download';

  link.classList.add('is-loading');

  fetch(href, { mode: 'cors' })
    .then(function(res) {
      if (!res.ok) throw new Error('Download failed: ' + res.status);
      return res.blob();
    })
    .then(function(blob) {
      // Work out an extension from the response type or the URL
      let ext = '';
      const typeMap = { 'image/jpeg': 'jpg', 'image/png': 'png', 'image/webp': 'webp', 'application/pdf': 'pdf' };
      if (typeMap[blob.type]) {
        ext = typeMap[blob.type];
      } else {
        const match = href.split('?')[0].match(/\.([a-z0-9]+)$/i);
        if (match) ext = match[1];
      }
      const fileName = ext && !baseName.toLowerCase().endsWith('.' + ext) ? baseName + '.' + ext : baseName;

      const objectUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = objectUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      setTimeout(function() { URL.revokeObjectURL(objectUrl); }, 1000);
    })
    .catch(function(err) {
      console.error('Order form download failed, opening in new tab instead.', err);
      window.open(href, '_blank', 'noopener');
    })
    .finally(function() {
      link.classList.remove('is-loading');
    });
});
